import { useState } from "react";

import { faCalendarCheck, faRuler } from "@fortawesome/free-solid-svg-icons";

import useCsvUploader from "./csvUploader";

import { doesFieldExist, createErrorObj } from "../../helpers/components/inputs";

const fieldOptions = [
  { label: "Date (MM/DD/YYYY)", value: "dateCommon" },
  { label: "Electricity (kwh)", value: "unitKwh" },
  { label: "Gas (therms)", value: "unitTherms" },
  { label: "Gas (CCF)", value: "unitCcf" },
  { label: "Gas (MCF)", value: "unitMcf" },
  { label: "Gas (Cubic Meters)", value: "unitCubicMeters" },
  { label: "Gas (Gallons Propane)", value: "unitGallonsPropane" }
];

const requiredFields = [
  {
    label: "Date",
    description: "When was this utility emission?",
    icon: faCalendarCheck
  },
  {
    label: "Unit",
    description: "What unit of measure was used for this utility emission?",
    icon: faRuler
  }
];

const knownFields = [
  { header: "dateCommon", field: "dateCommon" },
  { header: "date", field: "dateCommon" },
  { header: "Kwh", field: "unitKwh" },
  { header: "Gallons Propane", field: "unitGallonsPropane" },
  { header: "Therms", field: "unitTherms" },
  { header: "Cubic Meters", field: "unitCubicMeters" },
  { header: "Ccf", field: "unitCcf" },
  { header: "Mcf", field: "unitMcf" }
];

const fieldValidator = (headers) => {
  if (
    !doesFieldExist(headers, "dateCommon") &&
    !doesFieldExist(headers, "dateMMMMYY")
  ) {
    return createErrorObj("Your CSV must include a Date field");
  }
  if (
    !doesFieldExist(headers, "unitKwh") &&
    !doesFieldExist(headers, "unitGallonsPropane") &&
    !doesFieldExist(headers, "unitTherms") &&
    !doesFieldExist(headers, "unitMcf") &&
    !doesFieldExist(headers, "unitCcf") &&
    !doesFieldExist(headers, "unitCubicMeters")
  ) {
    return createErrorObj("Your CSV must include a Unit field");
  }
  return { success: true };
};

// Ticket #412: utilities_csv is a migrated Smart Upload family now -- this
// hook only uploads the matched CSV to Storage (same shape as
// shippingCsvUploader.js/bomProductsCsvUploader.js), rather than posting each
// row synchronously to /transactions/utility-sort. onNewObjectInBucket's own
// dispatch, utilitiesCsvTaskBuilder, and draftUtilitiesCsvChunk.js do the
// actual row processing asynchronously, going through review before any
// transaction gets written. officeId/officeName are per-upload metadata,
// same as legacy's selectedOfficeId/selectedOfficeName -- one building's
// meters per file.
const useUtilitiesCsvUploader = ({
  open,
  setOpen,
  selectedOfficeId,
  selectedOfficeName
}) => {
  const [fileInfo, setFileInfo] = useState({});
  const [matchedHeaders, setMatchedHeaders] = useState([]);

  return useCsvUploader({
    knownFields,
    fieldOptions,
    open,
    setOpen,
    fileInfo,
    setFileInfo,
    matchedHeaders,
    setMatchedHeaders,
    fieldValidator,
    docType: "utilities",
    firstStepText:
      "Upload a CSV of your utilities usage and we'll automatically calculate the emissions for each entry.",
    requiredFields,
    additionalMetadata: {
      officeId: selectedOfficeId || "",
      officeName: selectedOfficeName || ""
    }
  });
};

export default useUtilitiesCsvUploader;
